import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Action } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';

import { TranslationsApi } from '@vi-iot/client';

import { TranslationConfigService } from '@services';

import { environment } from '../../../environments/environment';

import { ViGuideChangeLog } from './changelog.model';
import { UpdatesActions } from './updates.actions';

@Injectable()
export class UpdatesEffects {
  getViGuideUpdates$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(UpdatesActions.getViGuideUpdates),
      switchMap(() =>
        this.http.get<ViGuideChangeLog[]>('/assets/changelog.json').pipe(
          map((updates) =>
            UpdatesActions.getViGuideUpdatesSuccess({
              updates,
            })
          ),
          catchError(() => of(UpdatesActions.getViGuideUpdatesError()))
        )
      )
    );
  });

  getViCareUpdates$: Observable<Action> = createEffect(() => {
    return this.actions$.pipe(
      ofType(UpdatesActions.getViCareUpdates),
      switchMap(() => {
        const lang = this.translationConfig.getLanguage();
        const langCode = lang ? lang.split('-')[0] : this.translationConfig.defaultLanguage;

        return this.translationsApi
          .getTranslationsFromPhraseappProject(langCode, environment.phraseappProjects.viCareId)
          .pipe(
            map((translations) =>
              UpdatesActions.getViCareUpdatesSuccess({
                translations,
              })
            ),
            catchError(() => of(UpdatesActions.getViCareUpdatesError()))
          );
      })
    );
  });

  constructor(
    private actions$: Actions,
    private http: HttpClient,
    private translationsApi: TranslationsApi,
    private translationConfig: TranslationConfigService
  ) {}
}
